import React from 'react';
import { getSubMethodIconStyle } from '../../utils/subPaymentMethods';
import { getThemeColor } from '../../config/appConfig';

const THEME = getThemeColor('primary');

const SubMethodIcon = ({ title, iconUrl }) => {
  if (iconUrl) {
    return (
      <img
        src={iconUrl}
        alt=""
        className="w-8 h-8 rounded-full object-cover shrink-0"
      />
    );
  }

  const style = getSubMethodIconStyle(title);
  return (
    <span
      className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold shrink-0"
      style={{ backgroundColor: style.bg, color: style.color }}
    >
      {style.label}
    </span>
  );
};

const SubPaymentMethodGrid = ({
  methods = [],
  selectedId = '',
  onSelect,
  isLoading = false,
  isDarkMode = false,
  title = 'Select Payment Network',
}) => {
  const text = isDarkMode ? 'text-white' : 'text-gray-900';
  const muted = isDarkMode ? 'text-gray-400' : 'text-gray-500';

  if (isLoading) {
    return (
      <div className="mt-4 pt-4 border-t border-gray-100">
        <p className={`text-xs font-medium mb-3 ${muted}`}>{title}</p>
        <div className={`text-sm ${muted}`}>Loading payment networks…</div>
      </div>
    );
  }

  if (!methods.length) return null;

  return (
    <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-gray-800' : 'border-gray-100'}`}>
      <p className={`text-xs font-medium mb-3 ${muted}`}>{title}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
        {methods.map((method) => {
          const active = selectedId === method.id;
          return (
            <button
              key={method.id}
              type="button"
              disabled={method.disabled}
              onClick={() => onSelect?.(method)}
              className={`flex items-center gap-3 p-3 rounded-lg border text-left transition ${
                method.disabled
                  ? 'opacity-50 cursor-not-allowed border-gray-200 bg-gray-50'
                  : active
                    ? 'border-red-800 bg-red-50'
                    : isDarkMode
                      ? 'border-gray-700 bg-gray-900 hover:border-red-800'
                      : 'border-gray-200 bg-white hover:border-red-200'
              }`}
              style={active ? { borderColor: THEME, color: THEME } : undefined}
            >
              <SubMethodIcon title={method.title} iconUrl={method.iconUrl} />
              <span className={`text-sm font-semibold leading-tight ${active ? '' : text}`}>
                {method.title}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SubPaymentMethodGrid;
